import { Fragment } from 'react';

import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import { mapFilterGroup } from 'src/mappers/models/filterGroupMapper';

import { TagOption } from 'src/types/FilterGroup';

import { searchContentQueryString } from 'src/utils/searchContentQueryString';

import ContentOverviewActionButton from 'src/components/contentOverview/contentOverviewActionButton/ContentOverviewActionButton';
import { CourseFields } from 'src/components/courseOverview/CourseFields';

import { ContentOverviewSummaryFields } from '../ContentOverviewSummaryFields';

import styles from './ContentOverviewAbstract.module.css';

type ContentOverviewAbstractProps = ComponentProps & {
	fields: ContentOverviewSummaryFields & CourseFields;
};

export default function ContentOverviewAbstract(props: ContentOverviewAbstractProps): JSX.Element {
	if (!props?.fields) {
		return <></>;
	}

	const filterGroups = mapFilterGroup(props.fields?.WildCardConfig?.FilterGroups ?? []) || [];

	const optionsToDisplay: TagOption[] = filterGroups
		.flatMap((filter) => {
			return filter?.options.map((option) => {
				const tagOption: TagOption = {
					filterName: filter.dtoPropertyName,
					optionId: option.title.replaceAll(' ', '-') + '_' + option.id,
					optionTitle: option.title,
				};

				return tagOption;
			});
		})
		.filter((tagOption: TagOption) => {
			if (tagOption.optionTitle && props.fields.Tags) {
				if (props.fields.Tags.flatMap((t) => t.fields.Title?.value).indexOf(tagOption.optionTitle) > -1) {
					return true;
				}
			}
			return false;
		});

	return (
		<div className={styles.abstract}>
			{optionsToDisplay && optionsToDisplay.length > 0 && (
				<div className={styles.tag}>
					{optionsToDisplay.map((tag, index) => {
						return (
							<Fragment key={index}>
								<a
									href={searchContentQueryString(
										tag.filterName,
										props.fields.WildCardConfig?.SearchListingWildcardPage?.value?.href,
										tag.optionId
									)}
									className={` link linkOffset linkHoverWeighted`}
								>
									#{tag.optionTitle && tag.optionTitle.replace(/^\s+|\s+$/g, '')}
								</a>
								{index + 1 < optionsToDisplay.length ? ', ' : ''}
							</Fragment>
						);
					})}
				</div>
			)}
			<RichText tag="div" field={props.fields.Strapline ? props.fields.Strapline : props.fields.Abstract} />

			<ContentOverviewActionButton removePadding {...props} />
		</div>
	);
}
